import { Platform } from 'react-native';
import dummyData from '../data.json';
import constants from '@/config/constants';
import { ExerciseType, Result, SetItem } from '../store.types';

export interface ExerciseStateModel {
  isSetChecked: boolean;
  sets: SetItem[];
  lastSyncedSets: object;
  assetsLinks: string[];
  chosenSets: [];
  chosenTasks: [];
  isUpperOrLowerLetter: unknown;
  currentExercisesWithTheirItems: unknown[];
  currentExerciseIndex: number;
  currentExerciseItemIndex: number;
  currentExerciseType: string;
  currentSetName: string;
  currentExerciseSetType: string;
  preventDisturbingExerciseProcess: boolean;
  hasSomethingChangedInSettings: boolean;
  practiceSessionsWithKey: Record<string, unknown[]>;
  resultsWithKey: Record<string, Result[]>;
  trackResult: {
    performance: string;
    os: Platform['OS'] | 'browser';
    app: string;
    appVersion: string;
    mistakes: number;
    exerciseType: ExerciseType | object;
    realUuid: string;
    uuid: string;
  };
  trackPracticeSession: {
    startDate: string;
    endDate: string;
    os: Platform['OS'] | 'browser';
    app: string;
    appVersion: string;
    uuid: string;
  };
  trackWrongTriesWritingResultCreation: unknown[];
  currentPracticeSessionDuration: number;
  compondPracticeSessionDuration: number;
  compondPracticeSessionDurationLastDate: string;
  starContainer: {
    lastProgress: null;
  };
  remainingTodayExerciseTimeInMinutes: number;
  lastTimeDurationUserExercisedBeforeLeavingTheExerciseWithoutFinishing10Minutes: number;
  resultModalWasShown: boolean;
  starsToGenerate: unknown[];
  userLeftExerciseBeforeFinishing10Minutes: boolean;
  exercisedDuration: number;
  showStarsPopUp: boolean;
  showNavigatingToHomeStarsPopUp: boolean;
  exercises: [
    {
      name: 'Understanding';
      iconName: 'ear-outline';
      iconLibrary: 'Ionicons';
    },
    {
      name: 'Speaking';
      iconName: 'bubble';
      iconLibrary: 'SimpleLineIcons';
    },
    {
      name: 'Reading';
      iconName: 'book-open';
      iconLibrary: 'SimpleLineIcons';
    },
    {
      name: 'Writing';
      iconName: 'pencil-outline';
      iconLibrary: 'Ionicons';
    },
  ];
}

export const exerciseStateModel: ExerciseStateModel = {
  ...dummyData,
  isSetChecked: false,
  sets: [],
  lastSyncedSets: {},
  assetsLinks: [],
  chosenSets: [],
  chosenTasks: [],
  isUpperOrLowerLetter: null,
  currentExercisesWithTheirItems: [],
  currentExerciseIndex: 0,
  currentExerciseItemIndex: 0,
  currentExerciseType: '',
  currentSetName: '',
  currentExerciseSetType: '',
  preventDisturbingExerciseProcess: false,
  hasSomethingChangedInSettings: false,
  practiceSessionsWithKey: {},
  resultsWithKey: {},
  trackResult: {
    performance: '',
    os: Platform.OS === 'web' ? 'browser' : Platform.OS,
    app: constants.appName,
    appVersion: constants.appVersion,
    mistakes: 0,
    exerciseType: {},
    realUuid: '',
    uuid: '',
  },
  trackPracticeSession: {
    startDate: '',
    endDate: '',
    os: Platform.OS === 'web' ? 'browser' : Platform.OS,
    app: constants.appName,
    appVersion: constants.appVersion,
    uuid: '',
  },
  trackWrongTriesWritingResultCreation: [],
  currentPracticeSessionDuration: 0,
  compondPracticeSessionDuration: 0,
  compondPracticeSessionDurationLastDate: '',
  starContainer: {
    lastProgress: null,
  },
  remainingTodayExerciseTimeInMinutes: 0,
  lastTimeDurationUserExercisedBeforeLeavingTheExerciseWithoutFinishing10Minutes: 0,
  resultModalWasShown: false,
  starsToGenerate: [],
  userLeftExerciseBeforeFinishing10Minutes: false,
  exercisedDuration: 0,
  showStarsPopUp: false,
  showNavigatingToHomeStarsPopUp: false,
  exercises: [
    {
      name: 'Understanding',
      iconName: 'ear-outline',
      iconLibrary: 'Ionicons',
    },
    {
      name: 'Speaking',
      iconName: 'bubble',
      iconLibrary: 'SimpleLineIcons',
    },
    {
      name: 'Reading',
      iconName: 'book-open',
      iconLibrary: 'SimpleLineIcons',
    },
    {
      name: 'Writing',
      iconName: 'pencil-outline',
      iconLibrary: 'Ionicons',
    },
  ],
};
